import { createModule } from '@Actions/utils';
import { SERVICE_ENDPOINT } from '@Apis/constants';

const GetMachineList = createModule({
  base: 'GET_MACHINE_LIST', apiDetails: {...SERVICE_ENDPOINT.MACHINE, method: 'get'},
});

const AddMachine = createModule({
  base: 'ADD_MACHINE', apiDetails: {...SERVICE_ENDPOINT.MACHINE, method: 'post'}, enableNotification: true,
});

const UpdateMachine = createModule({
  base: 'UPDATE_MACHINE', apiDetails: {...SERVICE_ENDPOINT.MACHINE, method: 'put'}, enableNotification: true,
});

const DeleteMachine = createModule({
  base: 'DELETE_MACHINE', apiDetails: {...SERVICE_ENDPOINT.MACHINE, method: 'delete'}, enableNotification: true,
});

export {
  GetMachineList, AddMachine, UpdateMachine, DeleteMachine,
};
